import { Sector, SectorValues } from '@/domain/impact/impact.entity';
import {
  ImpactCo2Answer,
  Source,
  SourceValues,
  ValuesWater,
} from '@/domain/impact-co2/entities/question.entity';
import { validateValueInType } from '@/domain/utils/validate-value-in-type';

import { QuestionWaterDto } from './dto.type';

export class QuestionWaterMapper {
  static dtoToEntity(dto: QuestionWaterDto): ImpactCo2Answer<ValuesWater> {
    return {
      id: dto.id,
      userId: dto.userId,
      sector: validateValueInType<Sector>(dto.sector, SectorValues),
      category: 'WATER',
      isExternal: dto.isExternal,
      source: validateValueInType<Source>(dto.source || '', SourceValues),
      values: {
        waterConsumptionVolume: Number.parseFloat(
          dto.waterConsumptionVolume.toString(),
        ),
        label: dto.label || '',
        score: dto.score || 0,
        tags:
          dto?.tags?.values?.map((tag) => ({ id: tag.id, name: tag.name })) ||
          [],
      },
    };
  }

  static entityToDto(
    answer: ImpactCo2Answer<ValuesWater>,
    projectId: number,
  ): Omit<QuestionWaterDto, 'id' | 'userId' | 'score' | 'isExternal'> {
    return {
      projectId: projectId,
      sector: answer.sector,
      waterConsumptionVolume: answer.values.waterConsumptionVolume,
      label: answer.values.label || '',
      source: answer.source !== '' ? answer.source : undefined,
      tags: { values: answer.values.tags },
    };
  }
}
